const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

function gtagSafe(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

export function trackEvent(eventName, params = {}) {
  gtagSafe('event', eventName, params);
}

export function trackPageView({ path, title } = {}) {
  if (!GA_ID) return;
  trackEvent('page_view', {
    page_path: path,
    page_title: title,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
  });
}

export function trackSearch({ query, resultCount } = {}) {
  if (!GA_ID) return;
  trackEvent('search', {
    search_term: String(query || '').trim(),
    result_count: Number(resultCount) || 0,
  });
}

export function initGoogleAnalytics() {
  if (!GA_ID || typeof window === 'undefined' || window.gtag) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });
}
